import { render } from "./ExampleDeviceScreenTiktok.vue?vue&type=template&id=42f804ce&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenTiktok.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenTiktok.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenTiktok.vue?vue&type=style&index=0&id=42f804ce&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f804ce"]])

export default __exports__